    //重定向下载地址
    var get_href_url = location.href;
    var Old_website = 'https://www.tozostore.com/';
    var New_website = 'https://buy.tozostore.com/';
    var Shopfiy_url = 'https://www.tozostore.com/';
    var requestParams = '';
    var Old_url = '';

    if (get_href_url.indexOf('?') !== -1) {
      requestParams = get_href_url.substr(get_href_url.indexOf('?') + 1); //截取?后面的内容作为字符串
      let num = get_href_url.indexOf("?")
      Old_url = get_href_url.substring(0,num)
    }else{
      Old_url = get_href_url
    }
    console.log(requestParams);

    console.log(Old_url);
    //产品说明书上的二维码重定向下载地址 兼容多语言路径
    // 使用正则表达式匹配路径
    const pathRegex = new RegExp(`^${Old_website}(?:[a-z]{2}/)?(download_health\.html|download_app\.html|warranty)`);
    const match = Old_url.match(pathRegex);

    if (match) {
      const pageType = match[1]; // 获取匹配的页面类型
      console.log('匹配到页面类型:', pageType);
      post_fun(pageType);
    } else {
      console.log('未匹配到任何页面类型:', Old_url);
    }

    //产品说明书上的二维码重定向下载地址 //多语言路径时有问题，如https://www.tozostore.com/ja/download_health.html
    // if(Old_url ==  Old_website + 'download_app.html'){
    //   //耳机下载地址
    //   post_fun('download_app.html')
    // }else if(Old_url == Old_website + 'download_health.html'){
    //   //手表下载地址
    //   post_fun('download_health.html')
    // }else if(Old_url == Old_website + 'download_health.html/'){
    //   //手表下载地址S3
    //   post_fun('download_health.html')
    // }else if(Old_url == Old_website + 'warranty'){
    //   //表单调查问卷
    //   post_fun('warranty')
    // }else{
    //   console.log(Old_url, '无');
    // }
    
    // //推广的原地址重定向
    // if(Old_url ==  Old_website + 'learn-more/GoldenX1'){
    //   post_fun('learn-more/GoldenX1')
    // }else{
    //   console.log(Old_url, '无');
    // }

    function post_fun(url){
      if(requestParams){
        location.href = New_website + url + '?' + requestParams
      }else{
        location.href = New_website + url
      }
    }

    //推广的原地址重定向
    // 为了处理旧官网的详情页地址重定向到新地址
    //截止网址后面的路由地址
    var pathname = window.location.pathname;
    if(pathname){
      console.log('pathname')
      
      console.log(pathname)
      //截止网址后面的第一个路由地址
      var router_first = pathname.split('/')[1];
      //截止网址后面的第二个路由地址
      var router_second = pathname.split('/')[2];
      

      if(router_first == 'learn-more'){
        if(router_second =='nc9'){
          location.href = Shopfiy_url + 'products/nc9' //原来的nc9重定向到现在的nc9
        }if(router_second =='GoldenX1'){
          location.href = Shopfiy_url + 'products/golden-x1' //原来的x1重定向到现在的x1
        }else{
          var new_web_url = New_website.substring(0, New_website.length - 1); //原因是上面定义的地址后面已经带了/,截取的路由也带了/，拼接就出现了两个，导致地址错误
          location.href = new_web_url + pathname //原来的产品详情页重定向到现在的buy上
        }
        
      }

      // 旧活动页重定向到活动的产品页
      if(pathname == '/pages/ht2_coloryoursound'){
        location.href = Shopfiy_url + 'products/ht2'
      }else if(pathname == '/pages/opentozorhythm2023'){
        location.href = Shopfiy_url + 'products/open-buds'
      }else if(pathname == '/contact-us-2'){
        location.href = Shopfiy_url + 'pages/support'
      }else if(pathname == '/pages/cyber-monday'){
        location.href = Shopfiy_url + 'pages/black-friday-cyber-monday-sale'
      }

      // 无用的vendors页面重定向到404
      if(pathname == '/collections/vendors'){
        location.href = Shopfiy_url + '404'
      }

      // 无用的旧页面重定向
      if(pathname == '/category/Earbuds'){
        location.href = Shopfiy_url + 'collections/headphones'
      }else if(pathname == '/t10guide'){
        location.href = Shopfiy_url + 'pages/manuals'
      }else if(pathname == '/support/TOZOAPP'){
        location.href = Shopfiy_url + 'pages/support'
      }else if(pathname == '/support/process-a-warranty'){
        location.href = Shopfiy_url + 'pages/process-a-warranty'
      }else if(pathname == '/support/manuals'){
        location.href = Shopfiy_url + 'pages/manuals'
      }else if(pathname == '/support'){
        location.href = Shopfiy_url + 'pages/support'
      }else if(pathname == '/product/tozo-t6-true-wireless-stereo-headphones-tws-bluetooth-in-ear-earbuds-with-charging-case-built-in-mic-headset-premium-sound-with-bass-for-running-sport-super-easy-pair-black/'){
        location.href = Shopfiy_url + 'products/t6'
      }else if(pathname == '/products/tozo-open-buds'){
        location.href = Shopfiy_url + 'products/open-buds'
      }else if(
        pathname == '/index' || 
        pathname == '/buygoods/63' || 
        pathname == '/buygoods/428' || 
        pathname == '/buygoods/372' || 
        pathname == '/buygoods/341' || 
        pathname == '/buygoods/340' || 
        pathname == '/buygoods/325' || 
        pathname == '/buygoods/26' || 
        pathname == '/buygoods/173'
      ){
        location.href = Shopfiy_url
      }
    }
